import React, { useEffect, useState } from 'react'
import './index.scss'
import { connect } from 'react-redux'
import ReusableButton from '../reusableComponents/button/customButton'
import TopMenuCoponent from './huntplanner-topmenu'
// import Map from '../../map'
import HuntMap from '../map/huntPlannerMap'
import { fetchHuntPlannerLayers } from '../../../action/huntplanner-state-Filter-actions'
// import ExistingMap from './existingMap'
import RightMenubar from './huntPlanner-right-toolbar/rightMenubar'
import Loader from '../reusableComponents/loader/Loader'
import { stopMapLoading, startMapLoading } from '../../../action/huntplanner-map-loader'
import { expandMorefilterMenu } from '../../../action/huntplanner-morefilters-actions'
import { huntPlannerRightMenuBarClose } from '../../../action/huntplanner-menu-bar'

const HuntplannerMainScreen = (props) => {
    let [loading, setLoading] = useState(true)

    useEffect(() => {
        setTimeout(() => {
            // setLoading(false)
            props.huntMapLoader && props.stopMapLoading()
        }, [1000 * 0.75])
    }, [])


    return (
        <div className='hunt-planner-container'>
            {/* {props.huntMapLoader &&
                <div className='hunt-planner-loading-map-container'>
                    <Loader left={props.huntplannerRightToolbar && !props.huntplannerMorefiltersExpand ? '42%' : props.huntplannerMorefiltersExpand ? '30%' : '50%'}></Loader>
                </div>
            } */}


            <TopMenuCoponent />

            {props.huntPlannerUnitRightMenuBar.expanded && <RightMenubar></RightMenubar>}

            <div className='hunt-planner-map-container'>
                {/* <Map width="calc(-78px + 100vw)" height="calc(-130px + 100vh)" top="68px" left="0px" /> */}
                <HuntMap
                    // width="calc(-23.4375vw - 78px + 100vw)" 
                    width="calc(100vw - 78px)"
                    height="calc(-130px + 100vh)"
                    top="68px"
                    left="0px" ></HuntMap>
                {/* <ExistingMap
                    width="calc(-78px + 100vw)"
                    height="calc(-130px + 100vh)"
                    top="0"
                    left="0px"
                    mapReference={props.mapReference}  // Pass the existing map instance
                /> */}
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    // mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null, pavan
    huntplannerMorefiltersExpand: state.huntplannerMorefiltersExpand,
    huntMapLoader: state.huntMapLoader,
    huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,
    huntplannerRightToolbar: state.huntplannerRightToolbar,
})

const mapDispatchToProps = dispatch => ({
    fetchHuntPlannerLayers: (cb) => dispatch(fetchHuntPlannerLayers(cb)),
    stopMapLoading: () => dispatch(stopMapLoading()),
    expandMorefilterMenu: (payload) => dispatch(expandMorefilterMenu(payload)),
    huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose())
})

export default connect(mapStateToProps, mapDispatchToProps)(HuntplannerMainScreen)